export default __webpack_public_path__ + "static/media/foto12.ce3b3bdd.jpg";